import Axios from "axios";
import {
    SET_HRM_GENDER_LIST,
    UNSET_HRM_GENDER_LIST,
  } from "@/store/mutation-types";
import {getHrmGenderList} from "@/store/api";
// initial state
const state = {
  getHrmGenderList: [],
};

const getters = {
  getHrmGenderList(state) {
    return state.getHrmGenderList;
  },
};

const mutations = {
  [SET_HRM_GENDER_LIST](state, data) {
    state.getHrmGenderList = data;
  },
  [UNSET_HRM_GENDER_LIST](state) {
    state.getHrmGenderList = [];
  },

};

const actions = {

  getHrmGenderList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmGenderList, data)
        .then(function (response) {
          commit('SET_HRM_GENDER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_GENDER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
